import React, { useState, useEffect } from "react";
import { Container, FormGroup, ButtonGroup, Col, Row, Button, Table, Badge } from "reactstrap";
import { toastBigError, toastBigSuccess, toastBigInfo } from "components/utils/toasts";
import { getBebidasDisponibles, notifyPedido } from "services/bebidaService";
import { getSalasSelect } from "services/salaService";
import { getUsers } from "services/userService";
import { savePedido } from "services/pedidoService";
import Select from "react-select";

const Pedir = (props) => {
  const { user } = props;

  const [mounted, setMounter] = useState(false);
  const [selectedSala, setSelectedSala] = useState(null);
  const [selectedBebida, setSelectedBebida] = useState(null);
  const [listaPedido, setListaPedido] = useState([]);
  const [salas, setSalas] = useState([]);
  const [bebidas, setBebidas] = useState([]);

  const fetchData = async () => {
    const salas = await getSalasSelect();
    const bebidas = await getBebidasDisponibles();
    setSalas(salas);
    setBebidas(bebidas);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (!mounted) fetchData();
  }, []);

  const handleSelectSala = (selectedOption, input) => {
    setSelectedSala(selectedOption);
  };

  const handleSelectBebida = (selectedOption, input) => {
    setSelectedBebida(selectedOption);
  };

  const handleAgregar = () => {
    const lista = [...listaPedido];
    const found = lista.find((element) => element.bebida === selectedBebida.label);
    if (!found) lista.push({ bebida: selectedBebida.label, cantidad: 1 });
    else toastBigInfo("Atención!", "Esta bebida ya está en el pedido");
    setListaPedido(lista);
  };

  const handleDecrement = (index) => {
    let lista = [...listaPedido];
    lista[index].cantidad--;
    if (lista[index].cantidad < 1) lista[index].cantidad = 1;
    setListaPedido(lista);
  };

  const handleIncrement = (index) => {
    let lista = [...listaPedido];
    lista[index].cantidad++;
    setListaPedido(lista);
  };

  const handleLimpiar = () => {
    setListaPedido([]);
  };

  const handleEnviar = async () => {
    const usuarios = await getUsers();
    const cacheUsuarios = [...usuarios];
    const filtered = cacheUsuarios.filter((usuario) => usuario.profile.isMaestranza);
    const data = {
      listaPedido: listaPedido,
      sala: selectedSala,
      usuarios: filtered,
      user: user,
    };
    if (filtered.length > 0) {
      const persistId = await savePedido(data);
      data.pedido = persistId;
      const response = await notifyPedido(data);
      if (response.data.success) {
        toastBigSuccess("Enviado!", "Pedido enviado correctamente");
        setListaPedido([]);
      } else toastBigError("Error!", "No se pudo notificar a personal de maestranza");
    } else {
      toastBigError("Error!", "No hay personal de maestranza que reciba el pedido!");
    }
  };

  return (
    <>
      <Container className="wrapper">
        <h3 className="mt-4 mb-2">Pedir Bebidas</h3>
        <Row className="justify-content-center mt-3">
          <Col md="6" sm="6">
            <FormGroup>
              <Select
                isSearchable={false}
                placeholder="Seleccione Sala"
                classNamePrefix="react-select"
                name="selectedSala"
                value={selectedSala}
                onChange={(selectedOption, input) => handleSelectSala(selectedOption, input)}
                options={salas}
              />
            </FormGroup>
          </Col>
        </Row>
        {/* <Row className="justify-content-center mt-5">
          <Col> */}
        <Row className="align-items-center justify-content-center mt-2">
          <Col>
            <Select
              isSearchable={false}
              placeholder="Seleccione Bebida"
              isDisabled={!selectedSala}
              classNamePrefix="react-select"
              name="selectedBebida"
              value={selectedBebida}
              onChange={(selectedOption, input) => handleSelectBebida(selectedOption, input)}
              options={bebidas}
            />
          </Col>
          <Col>
            <Button disabled={!selectedBebida} className="btn-sm" onClick={() => handleAgregar()}>
              + Agregar
            </Button>
          </Col>
        </Row>
        {/* </Col>
        </Row> */}
        <Row className="justify-content-center mt-5">
          <Col sm="12" md="12" className="d-flex justify-content-center">
            <h6>Pedido Actual</h6>
          </Col>
        </Row>
        <Table hover responsive striped className="mt-1">
          <thead>
            <tr>
              <th style={{ width: "80%" }}>Bebida</th>
              <th style={{ width: "20%", alignItems: "center" }}>Cantidad</th>
            </tr>
          </thead>
          <tbody>
            {listaPedido.map((pedido, index) => (
              <tr key={Math.random()}>
                <td>{pedido.bebida}</td>
                <td style={{ alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ButtonGroup className="mr-3">
                      <Button onClick={() => handleDecrement(index)} color="secondary">
                        -
                      </Button>
                    </ButtonGroup>
                    {pedido.cantidad}
                    <ButtonGroup className="ml-3">
                      <Button onClick={() => handleIncrement(index)} color="secondary">
                        +
                      </Button>
                    </ButtonGroup>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
      <Row className="justify-content-center mt-5">
        <Button disabled={listaPedido.length === 0} className="btn-sm mr-1" onClick={() => handleLimpiar()}>
          Borrar Pedido
        </Button>
        <Button disabled={listaPedido.length === 0} className="btn-sm ml-1" onClick={() => handleEnviar()}>
          Enviar Pedido
        </Button>
      </Row>
    </>
  );
};

export default Pedir;
